var map = {
	"./campus_1.png": 16,
	"./campus_10.png": 17,
	"./campus_11.jpg": 18,
	"./campus_13.jpeg": 19,
	"./campus_14.jpg": 20,
	"./campus_15.png": 21,
	"./campus_17.jpg": 22,
	"./campus_18.png": 23,
	"./campus_19.png": 24,
	"./campus_2.png": 25,
	"./campus_20.jpeg": 26,
	"./campus_21.png": 27,
	"./campus_22.png": 28,
	"./campus_23.png": 29,
	"./campus_24.jpg": 30,
	"./campus_25.png": 31,
	"./campus_26.png": 32,
	"./campus_27.png": 33,
	"./campus_28.png": 34,
	"./campus_29.png": 35,
	"./campus_30.jpg": 36,
	"./campus_31.png": 37,
	"./campus_32.jpg": 38,
	"./campus_5.png": 39,
	"./campus_7.png": 40,
	"./campus_9.png": 41,
	"./school_1.png": 42,
	"./school_10.png": 43,
	"./school_11.jpg": 44,
	"./school_12.png": 45,
	"./school_13.png": 46,
	"./school_14.png": 47,
	"./school_2.png": 48,
	"./school_3.JPG": 49,
	"./school_4.jpg": 50,
	"./school_5.png": 51,
	"./school_6.png": 52,
	"./school_7.jpg": 53,
	"./school_8.jpg": 54,
	"./school_9.png": 55,
	"./shopee_logo.png": 56,
	"./supporting_1.png": 57,
	"./supporting_2.png": 58,
	"./supporting_3.png": 59,
	"./training_1.png": 60
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 100;